module.exports = __webpack_public_path__ + "media/credit/mastercard-40eb8061.png";